import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetMyLevelV1Response } from './get-my-level-v1-response';
import { getMyLevelV1ResponseSchema } from './get-my-level-v1-response';

export async function getMyLevelV1Api(): Promise<IValidatedResponse<IGetMyLevelV1Response>> {
  return getRequest<IGetMyLevelV1Response>({
    path: '/account/level/v1',
    schema: getMyLevelV1ResponseSchema,
  });
}
